const PALETTE = [
  { name: 'brand-blue', hex: '#214592' },
  { name: 'forest-green', hex: '#1a6b3c' },
  { name: 'purple', hex: '#5b3fa6' },
  { name: 'warm-amber', hex: '#c46a00' },
  { name: 'teal', hex: '#0077a8' },
  { name: 'charcoal', hex: '#444444' },
  { name: 'deep-red', hex: '#8b1a1a' },
  { name: 'gold', hex: '#a07000' },
  { name: 'dark-teal', hex: '#2d6e6e' },
  { name: 'medium-grey', hex: '#888888' },
];

interface CategoryColorPickerProps {
  value: string;
  onChange: (hex: string) => void;
  label?: string;
}

export function CategoryColorPicker({ value, onChange, label = 'Color' }: CategoryColorPickerProps) {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-sm text-slate-700">{label}</span>
      <div role="radiogroup" aria-label={label} className="flex flex-wrap gap-2">
        {PALETTE.map((c) => (
          <button
            key={c.hex}
            type="button"
            role="radio"
            aria-checked={value === c.hex}
            aria-label={c.name}
            onClick={() => onChange(c.hex)}
            className={`w-7 h-7 rounded-full border-2 transition-shadow ${
              value === c.hex
                ? 'ring-2 ring-brand-orange ring-offset-1 border-white'
                : 'border-transparent hover:border-slate-300'
            }`}
            style={{ backgroundColor: c.hex }}
          />
        ))}
      </div>
    </div>
  );
}
